import React, { useState,useEffect } from "react";
// import Input from '../../Components/Atoms/Input/Input'
import {
  
  FormDropdown,
  FormField,
   
} from "../Components/Molecules/FormField/FormField";
import ErrorLabel from "../Components/Atoms/ErrorLabel/ErrorLabel";
import Checkbox from "../Components/Atoms/RadioButton/Checkbox";
import {
    CancelButton,
  PrimaryButton
} from "../Components/Atoms/Button/Button";
import HBar from "../Components/Bars/Bars";
import _ from "lodash"
import { get_master_data,branch_list,add_subscriber} from "../Enums/api_constunts"
import { postMethod } from "../Helpers/services";

import { SingleDatePicker } from "../Components/Atoms/SingleDatePicker/SingleDatePicker";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import moment from "moment";
import Card from "../Components/Atoms/Card/Card";
import {showToast} from "../Components/Atoms/ToastNotifier/ToastNotifier"
import styles from "../Pages/Dashboard/Dashboard.module.scss";
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export const SubScriptionForm = ({  HBarLabel,close_me,details,loaded_from="" }) => {
  
    const minAge =moment().subtract(18,"years").format("YYYY/MM/DD")
    const [selected_plan, setSelected_plan] = useState(null)
    const [subscription_plans, set_subscription_plans] = useState([])

    const userData = useSelector((state) => state.auth.user);
    const [OpenForm,setOpenForm] = useState(0)
    const [isSpinner, setIsSpinner] = useState(false);
    const [branchList, setBranchList] = useState([]);
    const [order_id, setOrderId] =useState(null)
    const [selectedTenant, setSelectedTenant ] = useState(()=>{
        if(_.get(userData, "tenant_details",null) !=null){
            return { ...userData["tenant_details"], "label":userData["tenant_details"]["name"] }
         
          
        }else{
          return null
        }
          
      })
      const getMasterData = ()=>{
        let postData = {"categories":["md_subscription_plans"]};
        //values["tenant_id"] = _.get(selectedTenant,"id");
         postMethod(get_master_data,postData).then((res)=>{
          
      
         if(_.get(res,"result.md_subscription_plans.length",0)>0){ 
         let md_service_types =   _.get(res,"result.md_subscription_plans",[]).map((item)=>{
            item["label"] =  item["name"]
            
            return item
          });
          set_subscription_plans(md_service_types)
        }
        
       
          
        })
      }
      useEffect(()=>{
        getMasterData()
      },[])
      const handleSubmit = (values,call_from=false) => {
        
        //sendPaymentLink termsAndCondatoons
        setIsSpinner(true);
        values["service_type_id"] = 1     
        if(_.has(values, "date_of_birth") && _.get(values, "date_of_birth","") ){
          values["date_of_birth"] =  moment(values["date_of_birth"]).format("YYYY-MM-DD")
         }
         if(loaded_from=="ENQUIRY_LIST" && _.get(details,"id",0)>0){
          values["enquiry_id"] =details["id"]
         }
         values["send_payment_link"] = sendPaymentLink
         if(call_from){
          values["send_payment_link"] = true
         }
         
         if(_.has(values,"mobile_no") && _.get(values,"mobile_no",false)){
          let mobile_no  = values["mobile_no"].trim()
          if (mobile_no.startsWith("+91-")) {
            
          } else {
            mobile_no = `+91-${mobile_no}`;
          }
          values["mobile_no"] =  mobile_no;
    
        }
           
         postMethod(add_subscriber,values).then((res)=>{
          showToast("success",_.get(res, "message","Successfully Added"))
          setOrderId(res?.order_id);
          setOpenForm(0)
          setIsSpinner(false);
           
          close_form()
        }).catch ((error)=>{
          showToast("error",_.get(error, "message","Something went wrong!"))
          setIsSpinner(false);
    
        })
      };
      const gender_list = [{"id":"Male", "label":"Male"},{"id":"Female", "label":"Female"},{"id":"Other", "label":"Other"}]
    let formData = {
        email: Yup.string()
          .email("Invalid email address")
          .required("Email is required")
          .min(2, "Must be at least 2 characters")
          .max(50, "Must be 50 characters or less"),
        first_name: Yup.string()
          .required("First name is required")
          .min(1, "Must be at least 2 characters")
          .max(50, "Must be 50 characters or less"),
        last_name: Yup.string()
          .required("Last name is required")
          .min(1, "Must be at least 2 characters")
          .max(50, "Must be 50 characters or less"),
        date_of_birth:Yup.string().required("Last name is required"),
        gender: Yup.string()
          .required("Gender is required"),
        mobile_no: Yup.string()
          .required("Mobile number is required")
          .matches(/^[0-9 + -]+$/, "Only numbers are allowed")
          .min(10, "Must be at least 10 characters")
          .max(15, "Must be 15 characters"),
         pan_card_number:Yup.string().required("PAN Card number is required"),
         aadhaar_card_number:Yup.string().required("Aadhaar Card number is required").matches(/^[0-9]+$/, "Only numbers are allowed"),
        nominee:Yup.string(),
        relation_with_nominee:Yup.string()


          
      
      }
      let initialValues ={
        email: _.get(details,"email",""),
        first_name: _.get(details,"name",""),
        last_name: "",
        date_of_birth:"",
        gender:'',
        mobile_no: _.get(details,"mobile_no",""),
        alternate_mobile_no:"",
        pan_card_number:"",
        aadhaar_card_number:"",
        nominee:"",
        relation_with_nominee:'',
        aadhaar_card:'',
        canceled_cheque:"",
        selfie:""
        
        
      }
      let formik = useFormik({
        initialValues:initialValues,
        validationSchema: Yup.object(formData),
        onSubmit: handleSubmit,
        validateOnBlur: true,
        validateOnChange: true,
      });
    
      const getBranchList = ()=>{
        let postData = {
          "search_string": "",
          "page": 1,
          "per_page": 100,
          "created_on": "",
          "created_to": "",
          "sort_by": "id",
          "sort_order": "desc",
          "status_ids": []
        }
        postMethod(branch_list,postData).then((res)=>{
          if(_.get(res, "list.length") >0){
            let list = res["list"].map((item)=>{
              item["label"] =  item["name"]
              
              return item
            });
            setBranchList(list);
          }
          
        })
    
      }
      useEffect(()=>{
        getBranchList()
      },[])
      const [imagePreview, setImagePreview] = useState(null);
  const [isPreviewVisible, setIsPreviewVisible] = useState(false); // New state to control the preview visibility
  
  

  // const handleFile = (e, field) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     // Set the preview URL for the selected file
  //     setImagePreview(URL.createObjectURL(file));
  //     formik.setFieldValue(field, file);  // Save the file in Formik state
  //     setIsPreviewVisible(false); // Reset preview visibility when a new file is selected
  //   }
  // };
  const handleFile = (event ,file_type='') => {
    const selectedFile = event.target.files[0];
    
    
    if (selectedFile) {
      // Validate if the file is an image
      formik.setFieldValue(file_type, ""); 
      if (selectedFile.type.startsWith('image/') ) {       
        
        const reader = new FileReader();
        reader.onloadend = () => {
         let data = {"file_name":selectedFile.name ,path:reader.result}
          formik.setFieldValue(file_type, JSON.stringify(data))
          
        };
        reader.readAsDataURL(selectedFile); // Convert to Base64
       
      } else {
        formik.setFieldValue(file_type, ""); // Clear the file if it's invalid
        formik.setFieldError(file_type, 'Please upload an image file (jpg, png, gif).');
        event.target.value=null
      }
    }
  };

  const handleRemoveImage = () => {
    setImagePreview(null);  // Clear the image preview
    formik.setFieldValue("selfie", null);  // Clear Formik field
    setIsPreviewVisible(false); // Hide preview after image is removed
  };

  const handleShowPreview = () => {
    setIsPreviewVisible(true); // Show the image preview
  };
  const close_form = ()=>{
    if (close_me){
      close_me()
    }
  }
  
   const [termsAndCondatoons,SetTermsAndCondatoons ] = useState(false)
   const [sendPaymentLink,SetsendPaymentLink ] = useState(false)
   
    return (<div>
      {/* <h3>Subscribe</h3>       */}
      <div className={'mt-3'}>
        
      <Card className="">
      <div className="pt-1">
      <div className="row">
                {/* <div className="col-md-12"> <div className="p-1 border bg-light text-center"> Add Agents
                </div>
                </div> */}
                
                <div className="col-md-4 mb-2">
                  <FormField
                    label="First Name"
                    id="first_name"
                    name="first_name"
                    type="text"
                    value={formik.values.first_name}
                    onChange={(e) =>
                      formik.setFieldValue("first_name", e.target.value)
                    }
                    error={formik.touched.first_name && formik.errors.first_name}
                    disableNumbers={true}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.first_name && <ErrorLabel
                    name="first_name"
                    formik={formik}
                    message={formik.errors.first_name}
                  />}
                </div>

                <div className="col-md-4 mb-2">
                  <FormField
                    label="Last Name"
                    id="last_name"
                    name="last_name"
                    type="text"
                    value={formik.values.last_name}
                    onChange={(e) =>
                      formik.setFieldValue("last_name", e.target.value)
                    }
                    error={formik.touched.last_name && formik.errors.last_name}
                    disableNumbers={true}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.last_name && <ErrorLabel
                    name="last_name"
                    formik={formik}
                    message={formik.errors.last_name}
                  />}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Email"
                    id="email"
                    name="email"
                    type="text"
                    value={formik.values.email}
                    onChange={(e) =>
                      formik.setFieldValue("email", e.target.value)
                    }
                    error={formik.touched.email && formik.errors.email}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.email && <ErrorLabel
                    name="email"
                    formik={formik}
                    message={formik.errors.email}
                  />}
                </div>
                
                <div className="col-md-4 mb-2">
                  <SingleDatePicker
                      selectedDate={formik.values.date_of_birth}
                      onDateChange={(date) => {
                        formik.setFieldValue("date_of_birth", date)
                        
                      }}
                      label="Date Of Birth"
                      placeholder="YYYY/MM/DD"
                      
                      maxDate={minAge}
                      datePickerClass={styles.datePickerClass}
                    />
                
                </div>

                <div className="col-md-4 mb-2">
                 
                  <FormDropdown
                    id="gender"
                    name="gender"
                    label="Select Gender"
                    options={gender_list}
                    onChange={(selected) => {
                      
                                           
                      if (selected?.label) {
                        
                        formik.setFieldValue("gender", selected?.label);
                        
                      }
                    }}
                    value={formik?.values?.gender}
                    error={
                      formik.touched.gender && formik.errors.gender
                    }
                    isImportant={false}
                    onBlur={formik.handleBlur}
                    disabled={false}
                  />
                  {formik.touched.gender && <ErrorLabel  name="gender" formik={formik}  message={formik.errors.gender}  />}
                </div>                 
                
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Mobile Number"
                    id="mobile_no"
                    name="mobile_no"
                    type="text"
                    value={formik.values.mobile_no}
                    onChange={(e) =>
                      formik.setFieldValue("mobile_no", e.target.value)
                    }
                    error={formik.touched.mobile_no && formik.errors.mobile_no}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.mobile_no && <ErrorLabel
                    name="mobile_no"
                    formik={formik}
                    message={formik.errors.mobile_no}
                  />}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Aternate mobile number"
                    id="alternate_mobile_no"
                    name="alternate_mobile_no"
                    type="text"
                    value={formik.values.alternate_mobile_no}
                    onChange={(e) =>
                      formik.setFieldValue("alternate_mobile_no", e.target.value)
                    }
                    error={formik.touched.alternate_mobile_no && formik.errors.alternate_mobile_no}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.alternate_mobile_no && <ErrorLabel  name="alternate_mobile_no"  formik={formik}  message={formik.errors.alternate_mobile_no}  />}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="PAN Card number"
                    id="pan_card_number"
                    name="pan_card_number"
                    type="text"
                    value={formik.values.pan_card_number}
                    onChange={(e) =>
                      formik.setFieldValue("pan_card_number", e.target.value)
                    }
                    error={formik.touched.pan_card_number && formik.errors.pan_card_number}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.pan_card_number && <ErrorLabel  name="pan_card_number"  formik={formik}  message={formik.errors.pan_card_number}  />}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Aadhaar Card number"
                    id="aadhaar_card_number"
                    name="aadhaar_card_number"
                    type="text"
                    value={formik.values.aadhaar_card_number}
                    onChange={(e) =>
                      formik.setFieldValue("aadhaar_card_number", e.target.value)
                    }
                    error={formik.touched.aadhaar_card_number && formik.errors.aadhaar_card_number}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.aadhaar_card_number && <ErrorLabel  name="aadhaar_card_number"  formik={formik}  message={formik.errors.aadhaar_card_number}  />}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Nominee"
                    id="nominee"
                    name="nominee"
                    type="text"
                    value={formik.values.nominee}
                    onChange={(e) =>
                      formik.setFieldValue("nominee", e.target.value)
                    }
                    error={formik.touched.nominee && formik.errors.nominee}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.nominee && <ErrorLabel  name="nominee"  formik={formik}  message={formik.errors.nominee}  />}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Relation with nominee"
                    id="relation_with_nominee"
                    name="relation_with_nominee"
                    type="text"
                    value={formik.values.relation_with_nominee}
                    onChange={(e) =>
                      formik.setFieldValue("relation_with_nominee", e.target.value)
                    }
                    error={formik.touched.relation_with_nominee && formik.errors.relation_with_nominee}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.relation_with_nominee && <ErrorLabel  name="relation_with_nominee"  formik={formik}  message={formik.errors.relation_with_nominee}  />}
                </div>
                <div className="col-md-6 mb-3">
           
              <FormDropdown
                id="selectedPlan"
                name="selectedPlan"
                label="Select Plan"
                options={subscription_plans}
                onChange={(selected) => {
                 
                  setSelected_plan(selected);
                  formik.setFieldValue("current_plan_id", selected?.id);
                  
                }}
                value={formik.values.selectedPlan}
                error={formik.touched.selectedPlan && formik.errors.selectedPlan}
                onBlur={()=>{formik.handleBlur();
                  
                }}
              />
              {formik.touched.selectedPlan && <ErrorLabel
              name="selectedPlan"
              formik={formik}
              message={formik.errors.selectedPlan}
            />}
            
                </div>

                    <div className="col-md-4 mb-2 mt-0">
                        
                    <FormDropdown
                        id="tenant_id"
                        name="tenant_id"
                        label="Select Branch"
                        options={branchList}
                        onChange={(selected) => {
                        setSelectedTenant({...selected})
                        
                        if (selected?.id) {
                            
                            formik.setFieldValue("tenant_id", selected?.id);
                        }
                        }}
                        value={selectedTenant?.label}
                        error={
                        formik.touched.tenant_id && formik.errors.tenant_id
                        }
                        isImportant={_.get(userData,"role_id") ==1}
                        onBlur={formik.handleBlur}
                        disabled={_.get(userData,"role_id") !=1}
                    />
                    {formik.touched.tenant_id && <ErrorLabel  name="tenant_id" formik={formik}  message={formik.errors.tenant_id}  />}
                    </div>
               
                    <div className="col-md-4 mb-2 ">
                    
                    <label htmlFor="aadhaar_card" className="form-label">
                    Aadhaar Card
                    </label>
                    <input
                        className="form-control"
                        type="file"
                        name="aadhaar_card"
                        id="aadhaar_card"
                        onChange={(e) => handleFile(e, "aadhaar_card")}
                    />
                    {formik.touched.aadhaar_card && <ErrorLabel name="aadhaar_card" formik={formik} message={formik.errors.aadhaar_card} />}
                    
                    {/* Show/Hide button */}
                            {/* <button
                    type="button"
                    className="btn btn-outline-secondary mt-2"
                    onClick={handleShowPreview}
                    disabled={!formik.values.selfie}
                    style={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                    <FaEye/>
                    </button> */}

                    {/* Conditionally show the preview and delete button */}
                    {isPreviewVisible && imagePreview && (
                        <div className="position-relative mt-2">
                        <img
                            src={imagePreview}
                            alt="selfie preview"
                            className="img-fluid rounded"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                        <button
                            type="button"
                            className="btn btn-danger position-absolute top-0 end-0"
                            style={{ zIndex: 10 }}
                            onClick={handleRemoveImage}
                        >
                            <span>&times;</span> {/* Close icon */}
                        </button>
                        </div>
                    )}
                    </div>
                    <div className="col-md-4 mb-2 ">
                    
                     <label htmlFor="canceled_cheque" className="form-label">
                     Canceled Cheque
                        
                    </label> 
                    <input
                        className="form-control"
                        type="file"
                        name="canceled_cheque"
                        id="canceled_cheque"
                        onChange={(e) => handleFile(e, "canceled_cheque")}
                    />
                    {formik.touched.canceled_cheque && <ErrorLabel name="canceled_cheque" formik={formik} message={formik.errors.canceled_cheque} />}
                    
                    {/* Show/Hide button */}
                            {/* <button
                    type="button"
                    className="btn btn-outline-secondary mt-2"
                    onClick={handleShowPreview}
                    disabled={!formik.values.selfie}
                    style={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                    <FaEye/>
                    </button> */}

                    {/* Conditionally show the preview and delete button */}
                    {isPreviewVisible && imagePreview && (
                        <div className="position-relative mt-2">
                        <img
                            src={imagePreview}
                            alt="selfie preview"
                            className="img-fluid rounded"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                        <button
                            type="button"
                            className="btn btn-danger position-absolute top-0 end-0"
                            style={{ zIndex: 10 }}
                            onClick={handleRemoveImage}
                        >
                            <span>&times;</span> {/* Close icon */}
                        </button>
                        </div>
                    )}
                    </div>
                    <div className="col-md-4 mb-2 ">
                    
                    <label htmlFor="selfie" className="form-label">
                        Upload Photo
                    </label>
                    <input
                        className="form-control"
                        type="file"
                        name="selfie"
                        id="selfie"
                        onChange={(e) => handleFile(e, "selfie")}
                    />
                    {formik.touched.selfie && <ErrorLabel name="selfie" formik={formik} message={formik.errors.selfie} />}
                    
                    {/* Show/Hide button */}
                            {/* <button
                    type="button"
                    className="btn btn-outline-secondary mt-2"
                    onClick={handleShowPreview}
                    disabled={!formik.values.selfie}
                    style={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                    <FaEye/>
                    </button> */}

                    {/* Conditionally show the preview and delete button */}
                    {isPreviewVisible && imagePreview && (
                        <div className="position-relative mt-2">
                        <img
                            src={imagePreview}
                            alt="selfie preview"
                            className="img-fluid rounded"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                        <button
                            type="button"
                            className="btn btn-danger position-absolute top-0 end-0"
                            style={{ zIndex: 10 }}
                            onClick={handleRemoveImage}
                        >
                            <span>&times;</span> {/* Close icon */}
                        </button>
                        </div>
                    )}
                    </div>
                                
                
      </div>
      <div className="row">
        <div className="col-md-6 mb-2 " >
        <Checkbox
        label="Terms And Conditions"
        id="tc"
        name="tc"
        options={[{name:'Accept',value:false}]}
        onChange={(v)=>{
          SetTermsAndCondatoons(v)
         // alert(v)
        }}
        />
        </div>
        <div className="col-md-6 mb-2 " >
        <Checkbox
        label="Send Payment Link To User"
        id="send_payment_link"
        name="send_payment_link"
        options={[{name:'Accept',value:false}]}
        onChange={(v)=>{
          SetsendPaymentLink(v)
         // alert(v)
        }}
        />
        </div>
      </div>
      <div className="row justify-content-end w-100">
            <div className="d-flex justify-content-end" style={{ gap: "16px" }}>
              <CancelButton label="Cancel" onClick={()=>close_form()} className="btn btn-secondary" />
              {/* <PrimaryButton
                type="submit"
                onClick={(data)=>formik.handleSubmit(data,"from_payment")}
                spinner={isSpinner}
                label="Send Payment Link"
                disabled={!(formik.dirty && formik.isValid)}
              /> */}
              <PrimaryButton
                type="submit"
                onClick={formik.handleSubmit}
                spinner={isSpinner}
                label="Submit"
                disabled={!(formik.dirty && formik.isValid)}
              />
            </div>
          </div>

      </div>
      </Card>


      </div>
    </div>)

}